import { createAction } from "redux-actions";
import { SET_APPLIED } from "./constants";
import { SetApplied } from "./types";

export const setApplied: SetApplied = createAction(SET_APPLIED);
